var _defs, _path, _g, _path2, _rect, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "main_logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 194.26,
    height: 41.366,
    viewBox: "0 0 194.26 41.366",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16726",
    "data-name": "Rectangle 16726",
    width: 138.325,
    height: 24.453,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16728",
    "data-name": "Rectangle 16728",
    width: 42.354,
    height: 13.585,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16729",
    "data-name": "Rectangle 16729",
    width: 194.26,
    height: 41.366,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_76173",
    "data-name": "Path 76173",
    d: "M179.666,28.478h-6.152v3.647h5.976v2.9h-5.976v5.932h-3.032V25.578h9.184Z",
    transform: "translate(-114.101 -17.119)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_45402",
    "data-name": "Group 45402",
    transform: "translate(54.953 5.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45401",
    "data-name": "Group 45401",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76174",
    "data-name": "Path 76174",
    d: "M212.352,38.243h2.834V49.228h-2.834v-1.3a4.313,4.313,0,0,1-3.581,1.6A4.977,4.977,0,0,1,205,47.854a6.187,6.187,0,0,1,0-8.239,4.977,4.977,0,0,1,3.768-1.681,4.314,4.314,0,0,1,3.581,1.6Zm-5.229,7.723a2.926,2.926,0,0,0,2.175.868,2.964,2.964,0,0,0,2.186-.868,3.3,3.3,0,0,0,0-4.46,2.965,2.965,0,0,0-2.186-.868,2.927,2.927,0,0,0-2.175.868,3.33,3.33,0,0,0,0,4.46",
    transform: "translate(-191.107 -30.553)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76175",
    "data-name": "Path 76175",
    d: "M259.56,37.935a3.906,3.906,0,0,1,3.021,1.23,4.679,4.679,0,0,1,1.132,3.3v6.767h-2.834V42.659a2.251,2.251,0,0,0-.483-1.538,1.719,1.719,0,0,0-1.362-.549,1.862,1.862,0,0,0-1.5.637,2.787,2.787,0,0,0-.538,1.846v6.173h-2.834V42.659a2.253,2.253,0,0,0-.483-1.538,1.72,1.72,0,0,0-1.362-.549,1.9,1.9,0,0,0-1.505.637,2.715,2.715,0,0,0-.56,1.846v6.173H247.41V38.243h2.834v1.164a3.422,3.422,0,0,1,3.054-1.472,3.256,3.256,0,0,1,2.988,1.582,3.724,3.724,0,0,1,3.274-1.582",
    transform: "translate(-220.541 -30.553)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76176",
    "data-name": "Path 76176",
    d: "M305.415,27.809a1.763,1.763,0,0,1-1.736-1.736,1.7,1.7,0,0,1,.516-1.231,1.649,1.649,0,0,1,1.219-.527,1.675,1.675,0,0,1,1.242.527,1.705,1.705,0,0,1,.516,1.231,1.669,1.669,0,0,1-.516,1.219,1.693,1.693,0,0,1-1.242.516m-1.406,1.318h2.834V40.113h-2.834Z",
    transform: "translate(-258.201 -21.438)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16725",
    "data-name": "Rectangle 16725",
    width: 2.834,
    height: 16.038,
    transform: "translate(51.454 2.636)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76177",
    "data-name": "Path 76177",
    d: "M343.428,38.865h3.032l-4,10.985a7.236,7.236,0,0,1-2.274,3.438,5.226,5.226,0,0,1-3.526.956V51.608a2.849,2.849,0,0,0,1.813-.484,3.377,3.377,0,0,0,1.065-1.626l-4.5-10.633h3.1l2.856,7.382Z",
    transform: "translate(-279.187 -31.176)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76178",
    "data-name": "Path 76178",
    d: "M380.429,25.579a5.114,5.114,0,0,1,3.735,1.494,5.2,5.2,0,0,1,0,7.338,5.113,5.113,0,0,1-3.735,1.494h-2.7v5.053H374.7V25.579Zm0,7.492a2.121,2.121,0,0,0,1.6-.67,2.493,2.493,0,0,0,0-3.329,2.139,2.139,0,0,0-1.6-.659h-2.7v4.657Z",
    transform: "translate(-305.731 -22.283)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76179",
    "data-name": "Path 76179",
    d: "M420.263,29.665a3.978,3.978,0,0,1,2.977,1.208,4.588,4.588,0,0,1,1.176,3.339v6.745h-2.834V34.565a2.251,2.251,0,0,0-.593-1.681,2.163,2.163,0,0,0-1.582-.582,2.335,2.335,0,0,0-1.758.681,2.834,2.834,0,0,0-.659,2.043v5.932h-2.834V25.579h2.834V31.2a3.66,3.66,0,0,1,3.274-1.538",
    transform: "translate(-332.141 -22.283)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76180",
    "data-name": "Path 76180",
    d: "M461.355,47.854a5.861,5.861,0,1,1,1.692-4.119,5.638,5.638,0,0,1-1.692,4.119M455.1,45.91a2.857,2.857,0,0,0,2.12.857,2.894,2.894,0,0,0,2.131-.857,3.189,3.189,0,0,0,0-4.35,2.894,2.894,0,0,0-2.131-.857,2.857,2.857,0,0,0-2.12.857,3.219,3.219,0,0,0,0,4.35",
    transform: "translate(-357.085 -30.553)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76181",
    "data-name": "Path 76181",
    d: "M496.918,35.364h-2.483v4.57a1.088,1.088,0,0,0,.285.835,1.313,1.313,0,0,0,.835.3,12.384,12.384,0,0,0,1.362-.011v2.57q-2.922.33-4.119-.549a3.655,3.655,0,0,1-1.2-3.142v-4.57H489.69V32.64H491.6V30.421l2.834-.857V32.64h2.483Z",
    transform: "translate(-382.695 -24.951)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76182",
    "data-name": "Path 76182",
    d: "M525.528,47.854a5.861,5.861,0,1,1,1.692-4.119,5.638,5.638,0,0,1-1.692,4.119m-6.25-1.944a2.857,2.857,0,0,0,2.12.857,2.894,2.894,0,0,0,2.131-.857,3.189,3.189,0,0,0,0-4.35A2.894,2.894,0,0,0,521.4,40.7a2.857,2.857,0,0,0-2.12.857,3.219,3.219,0,0,0,0,4.35",
    transform: "translate(-400.035 -30.553)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76183",
    "data-name": "Path 76183",
    d: "M557.822,41.362q0,.44.582.714a7.753,7.753,0,0,0,1.417.484,14.745,14.745,0,0,1,1.67.527,3.246,3.246,0,0,1,1.417,1.066,2.947,2.947,0,0,1,.582,1.868,3.017,3.017,0,0,1-1.263,2.6,5.251,5.251,0,0,1-3.153.912q-3.384,0-4.614-2.614l2.461-1.384a2.036,2.036,0,0,0,2.153,1.428q1.516,0,1.516-.945,0-.439-.582-.714a8.364,8.364,0,0,0-1.417-.494,14.773,14.773,0,0,1-1.67-.549,3.424,3.424,0,0,1-1.417-1.044,2.74,2.74,0,0,1-.582-1.791,3.068,3.068,0,0,1,1.2-2.559,4.694,4.694,0,0,1,2.977-.934,4.98,4.98,0,0,1,2.439.6,4.42,4.42,0,0,1,1.736,1.725l-2.417,1.318a1.808,1.808,0,0,0-1.757-1.121,1.613,1.613,0,0,0-.912.242.754.754,0,0,0-.362.659",
    transform: "translate(-426.045 -30.553)"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_76184",
    "data-name": "Path 76184",
    d: "M463.478,91.166l1.172,3.491h-2.343Zm-1.05-1.941-2.99,8.544h1.819l.513-1.538h3.405l.513,1.538h1.831l-3-8.544Z",
    transform: "translate(-307.495 -59.717)",
    fill: "gray"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16727",
    "data-name": "Rectangle 16727",
    width: 1.575,
    height: 8.91,
    transform: "translate(162 29.142)",
    fill: "gray"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_45404",
    "data-name": "Group 45404",
    transform: "translate(151.906 27.677)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45403",
    "data-name": "Group 45403",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76185",
    "data-name": "Path 76185",
    d: "M506.171,91.5a2.779,2.779,0,0,1,2.105.934,3.437,3.437,0,0,1,0,4.577,2.778,2.778,0,0,1-2.105.934,2.361,2.361,0,0,1-1.977-.891v.72h-1.575V89.225h1.575v3.161a2.362,2.362,0,0,1,1.977-.891m-1.5,4.461a1.625,1.625,0,0,0,1.208.482,1.645,1.645,0,0,0,1.214-.482,1.833,1.833,0,0,0,0-2.478A1.647,1.647,0,0,0,505.878,93a1.626,1.626,0,0,0-1.208.482,1.85,1.85,0,0,0,0,2.478",
    transform: "translate(-488.302 -87.394)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76186",
    "data-name": "Path 76186",
    d: "M533.243,96.607h1.575v6.1h-1.575v-.684a2.033,2.033,0,0,1-1.819.854,2.208,2.208,0,0,1-1.654-.671,2.547,2.547,0,0,1-.653-1.855V96.607h1.575v3.552a1.249,1.249,0,0,0,.329.934,1.2,1.2,0,0,0,.879.324,1.3,1.3,0,0,0,.977-.379,1.573,1.573,0,0,0,.366-1.135Z",
    transform: "translate(-506.036 -92.335)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76187",
    "data-name": "Path 76187",
    d: "M561.112,96.09a2.171,2.171,0,0,1,1.678.684,2.6,2.6,0,0,1,.629,1.831v3.759h-1.575V98.714a1.251,1.251,0,0,0-.269-.854.955.955,0,0,0-.757-.305,1.035,1.035,0,0,0-.836.354,1.549,1.549,0,0,0-.3,1.025v3.43h-1.575V98.714a1.252,1.252,0,0,0-.268-.854.956.956,0,0,0-.757-.305,1.058,1.058,0,0,0-.836.354,1.508,1.508,0,0,0-.311,1.025v3.43h-1.575v-6.1h1.575v.647a1.9,1.9,0,0,1,1.7-.818,1.809,1.809,0,0,1,1.66.879,2.07,2.07,0,0,1,1.819-.879",
    transform: "translate(-522.933 -91.989)",
    fill: "gray"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "main_logo-2",
    "data-name": "main_logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45405",
    "data-name": "Group 45405",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76188",
    "data-name": "Path 76188",
    d: "M13.327,4.424A4.424,4.424,0,1,1,8.9,0a4.424,4.424,0,0,1,4.424,4.424",
    transform: "translate(-2.998)",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76189",
    "data-name": "Path 76189",
    d: "M57.972,31.209a4.424,4.424,0,1,1-4.425-4.426,4.425,4.425,0,0,1,4.425,4.426",
    transform: "translate(-32.878 -17.925)",
    fill: "#23cc2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76190",
    "data-name": "Path 76190",
    d: "M102.615,58.112a4.424,4.424,0,1,1-4.424-4.424,4.424,4.424,0,0,1,4.424,4.424",
    transform: "translate(-62.757 -35.933)",
    fill: "#4464ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76191",
    "data-name": "Path 76191",
    d: "M35.435,53.5H26.576V50.543a5.893,5.893,0,0,0-.127-1.221c-.016-.074-.032-.147-.051-.22a5.65,5.65,0,0,0-.181-.59c-.033-.09-.068-.179-.106-.267s-.076-.175-.118-.262-.085-.171-.13-.254a5.931,5.931,0,0,0-2.379-2.379q-.125-.067-.254-.13c-.087-.041-.174-.081-.262-.118S22.792,45.03,22.7,45a5.567,5.567,0,0,0-.59-.182c-.073-.019-.146-.035-.22-.05a5.844,5.844,0,0,0-1.221-.127h-.163a1.132,1.132,0,0,0-.124,0h-.033c-.045,0-.09,0-.133.008-.066,0-.132.011-.2.019s-.1.011-.156.019h-.028c-.063.008-.124.019-.183.029s-.13.023-.194.037l-.018,0c-.059.012-.118.024-.175.04h-.01c-.116.027-.228.059-.34.094l-.081.026c-.045.014-.088.029-.132.045l-.021.008c-.059.02-.118.042-.175.065s-.121.048-.181.075-.093.04-.139.063l-.074.034-.14.071-.157.081-.027.016c-.053.028-.1.059-.155.09s-.11.068-.163.1-.108.071-.163.108-.1.069-.147.1l-.02.016-.143.11-.147.121c-.095.081-.187.163-.277.253a.072.072,0,0,0-.016.016c-.042.042-.081.081-.127.129s-.088.093-.132.141-.086.1-.127.145a5.24,5.24,0,0,0-.353.461c-.06.087-.117.175-.172.265-.042.068-.081.138-.122.209l-.013.022L15.5,47.7c-.05.09-.1.181-.143.275l-.007.014q-.067.142-.128.286l-.011.025c-.041.1-.081.2-.114.3l-.009.027a5.886,5.886,0,0,0-.315,1.9v.111a5.876,5.876,0,0,0,.788,2.841h-.789a2.952,2.952,0,0,1-2.952-2.952V41.684a5.889,5.889,0,0,0-1.73-4.175,5.68,5.68,0,0,0-.81-.674A5.9,5.9,0,0,0,0,41.684v8.859A14.754,14.754,0,0,0,14.745,65.307H35.433a5.906,5.906,0,0,0,0-11.812",
    transform: "translate(0 -23.941)",
    fill: "#252533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76192",
    "data-name": "Path 76192",
    d: "M50.088,26.291q.134-.132.277-.253c-.1.081-.187.163-.277.253",
    transform: "translate(-33.523 -17.427)",
    fill: "#252533"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/main_logo.1811215880b09008819db108b49776a4.svg";
export { ForwardRef as ReactComponent };